import React, { useContext, useEffect, useState } from "react";
import SidebarContext from "../../contexts/MyContext";
import Button from "../button/button";
import Modal from "../Modal/Modal";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import { truncateFileName } from "../../utils/truncateFileName";
import { errorToast } from "../../utils/notificationUtils";
import { formatTimeWithOptionalHours, durationToSeconds } from "../../utils/timeFile";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import { Icon } from "@iconify/react";
import "../../css/app/editTools.css";

const ConvertRecordingLogic = () => {
    const { selectedConvertAudio, setSelectedConvertAudio, setAudioData, folderAudioData, setFolderAudioData, folders, setFolders, setTabIndex, setFilterAudioData, setActionTabIndex, setAudio
    } =
        useContext(SidebarContext);
    // console.log("🚀 ~ ConvertRecordingLogic ~ selectedConvertAudio:", selectedConvertAudio)

    const [openModal, setOpenModal] = useState(false);
    const [recordingName, setRecordingName] = useState("");
    const [selectedFormat, setSelectedFormat] = useState("");
    // console.log("🚀 ~ ConvertRecordingLogic ~ selectedFormat:", selectedFormat);
    const [loading, setLoading] = useState(false);
    const [initialRecordingName, setinitialRecordingName] = useState('')
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const maxLength = 100; // Define the maximum length



    const handleFormatChange = (event) => {
        setSelectedFormat(event.target.value);
    };

    const handleClose = () => {
        setOpenModal(false);
        // setRecordingName("");
    };

    const doHandleConvertAndSaveAudio = async (e, file) => {
        // console.log(file);
        e.preventDefault();
        const randomAudioName = `Converted${generateRandomNumber()}`;
        const convertRecordingName = randomAudioName.trim();

        try {
            setLoading(true);
            const id = selectedConvertAudio?._id;
            const FolderId = selectedConvertAudio?.folderId || selectedConvertAudio?.audio?.folderId
            const convertFile = {
                id: id,
                fileUrl: file,
                selectedFormat: selectedFormat,
                fileName: convertRecordingName,
                action: 'Convert'
            };
            const data = await AudioHandler.doConvertAudioRecording(id, convertFile, FolderId);

            if (data?.statusCode === 200) {
                setFilterAudioData((pre) => [data.data, ...pre]);
                setOpenModal(false);
                setLoading(false);
                setSelectedConvertAudio([]);
                setRecordingName("");
                // setTabIndex((prevState) => setTabIndex(prevState))
                setActionTabIndex(null);
                setAudio()
            }
            else {
                errorToast(data?.response?.data?.error)
                setLoading(false)

            }
        } catch (error) {
            console.log("🚀 ~ doHandleConvertAndSaveAudio ~ error:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedConvertAudio?.audio?.fileName) {
            const parts = selectedConvertAudio?.audio?.fileName.split(".");
            setSelectedFormat(parts[1]);
            setRecordingName(parts[0])
            setinitialRecordingName(parts[0])


        } else {
            setSelectedFormat("mp3");
        }
    }, [selectedConvertAudio]);

    useEffect(() => {
        const isValidAudioConvertName = typeof recordingName === 'string' && recordingName.length >= 3;

        setIsButtonDisabled(recordingName === "" || recordingName === initialRecordingName || !isValidAudioConvertName);

    }, [recordingName, initialRecordingName]);

    const fileName = selectedConvertAudio.audio?.fileName;
    const extension = fileName?.includes(".")
        ? fileName.slice(fileName.lastIndexOf(".") + 1)
        : "";
    // console.log("🚀 ~ ConvertRecordingLogic ~ extension:", extension);

    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // Limit the length of the input value
        if (inputValue.length <= maxLength) {
            setRecordingName(inputValue);
        }
    };

    return (
        <div className="vr-edit vr-tone-sky">


            {!selectedConvertAudio?.audio ? (
                <>

                    <div className="vr-edit-empty">
                        <img src="/img/convert.png" alt="convert" />
                        <h3>
                            Select Recording for Convert
                        </h3>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting
                            industry. Lorem Ipsum has been the industry's
                        </p>
                    </div>
                </>
            ) : (
                <>
                    <div className="vr-edit-head">
                        <span className="vr-icon-tile is-solid"><Icon icon="lucide:arrow-right-left" width={20} height={20} /></span>
                        <div className="vr-edit-head-text">
                            <h6 className="vr-edit-title">
                                Convert
                            </h6>
                            <div className="vr-edit-file">
                                <Icon icon="lucide:audio-lines" width={16} height={16} role="img" aria-label="audio" />
                                <h6>
                                    {truncateFileName(selectedConvertAudio?.audio?.fileName, 30)}
                                </h6>
                                {/* <div className="d-flex">
                                    <p
                                        style={{
                                            marginBottom: "0px",
                                            color: "#94A3B8",
                                            marginRight: "10px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        {formatTimeWithOptionalHours(durationToSeconds(selectedConvertAudio?.audio?.timeDuration))}
                                    </p>

                                    <p
                                        style={{
                                            background: "#F1F5F9",
                                            color: "#94A3B8",
                                            borderRadius: "5px",
                                            padding: "1px 4px",
                                            fontSize: "12px",
                                            marginBottom: "0",
                                        }}
                                    >
                                        {extension}
                                    </p>
                                </div> */}
                            </div>
                        </div>
                        {/* <Button
                            btnText={"Cancel"}
                            primary
                            onClick={() => setSelectedConvertAudio("")}
                        /> */}
                        <button type="button" className="vr-iconbtn is-bordered vr-edit-close" aria-label="Close" onClick={(e) => { setActionTabIndex(null) }}>
                            <Icon icon="lucide:x" width={18} height={18} />
                        </button>
                    </div>

                    <div className="vr-edit-card">
                        <p className="vr-edit-label">Select audio format</p>
                        <div className="vr-edit-formats vr-stagger">
                            <div
                                className={`vr-edit-format${selectedFormat === "mp3" ? " is-selected" : ""}`}
                                onClick={() => setSelectedFormat('mp3')}
                            >
                                <span className="vr-icon-tile"><Icon icon="lucide:file-audio" width={18} height={18} /></span>
                                <div className="vr-edit-format-body">
                                    <label
                                        className="form-check-label"
                                        htmlFor="mp3Radio"
                                        onClick={() => setSelectedFormat("mp3")}
                                    >
                                        mp3
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="convert"
                                        id="mp3Radio"
                                        value="mp3"
                                        checked={selectedFormat === "mp3"}
                                        onChange={handleFormatChange}
                                    />
                                </div>
                            </div>
                            {/* <div
                                className="col-3"
                                style={{
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "8px",
                                    padding: "12px 24px",
                                    width: '30%',
                                    cursor: 'pointer'

                                }}
                                onClick={() => setSelectedFormat('m4a')}

                            >
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", cursor: 'pointer' }}

                                >
                                    <label
                                        for={"m4a"}
                                        className="form-check-label"
                                        htmlFor="m4aRadio"
                                        style={{
                                            color: selectedFormat === "m4a" ? "#000000" : "#94A3B8",
                                        }}
                                        onClick={() => setSelectedFormat("m4a")}
                                    >
                                        m4a
                                    </label>
                                    <input
                                        type={"radio"}
                                        name={"convert"}
                                        value={"m4a"}
                                        id={"m4a"}
                                        className="form-check-input"
                                        checked={selectedFormat === "m4a"}
                                        onChange={handleFormatChange}
                                    />
                                </div>
                            </div> */}
                            {/* <div
                                className="col-3"
                                style={{
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "8px",
                                    padding: "12px 24px",
                                    width: '30%',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setSelectedFormat('caf')}
                            >
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", cursor: 'pointer' }}
                                >
                                    <label
                                        className="form-check-label"
                                        htmlFor="mp3Radio"
                                        style={{
                                            color: selectedFormat === "caf" ? "#000000" : "#94A3B8",
                                        }}
                                        onClick={() => setSelectedFormat("caf")}
                                    >
                                       caf
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="convert"
                                        id="mp3Radio"
                                        value="caf"
                                        checked={selectedFormat === "caf"}
                                        onChange={handleFormatChange}
                                    />
                                </div>
                            </div> */}

                            <div
                                className={`vr-edit-format${selectedFormat === "wav" ? " is-selected" : ""}`}
                                onClick={() => setSelectedFormat('wav')}

                            >
                                <span className="vr-icon-tile"><Icon icon="lucide:file-audio" width={18} height={18} /></span>
                                <div className="vr-edit-format-body">
                                    <label
                                        for={"wav"}
                                        className="form-check-label"
                                        htmlFor="m4aRadio"
                                    >
                                        wav
                                    </label>
                                    <input
                                        type={"radio"}
                                        name={"convert"}
                                        value={"wav"}
                                        id={"wav"}
                                        className="form-check-input"
                                        checked={selectedFormat === "wav"}
                                        onChange={handleFormatChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="vr-edit-convert-foot">
                            <button
                                className="vr-btn vr-btn-primary"
                                // onClick={() => setOpenModal(true)}
                                onClick={(e) => {
                                    doHandleConvertAndSaveAudio(
                                        e,
                                        selectedConvertAudio?.audio?.url
                                    );
                                }}
                                disabled={selectedFormat === extension ? true : false}
                            >
                                <div>
                                    <Icon icon="lucide:download" width={18} height={18} role="img" aria-label="dawonload" />
                                    <span>

                                        {loading ? (
                                            <>
                                                <div
                                                    className="spinner-border"
                                                    role="status"
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <span> Convert & Save</span>
                                            </>
                                        )}

                                    </span>
                                </div>

                            </button>
                        </div>
                    </div>
                    {openModal && (
                        <Modal onClose={() => handleClose()} modaltxt={"Save recording"}
                            closeButtonDisabled={loading}
                        >
                            <div className="vr-edit-modal">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="vr-input input-field"
                                        id="recordingname"
                                        name="recordingname"
                                        placeholder="Recording name"
                                        value={recordingName}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <div className="vr-edit-count">
                                        {`${recordingName?.length}/${maxLength}`}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        disabled={isButtonDisabled || loading}
                                        onClick={(e) => {
                                            if (!loading) {
                                                // Only call handalMergeAudio if load is false
                                                doHandleConvertAndSaveAudio(
                                                    e,
                                                    selectedConvertAudio?.audio?.url
                                                );
                                            }
                                        }}
                                        className="vr-btn vr-btn-primary vr-btn-block"
                                    >
                                        {loading ? (
                                            <>
                                                <div
                                                    className="spinner-border"
                                                    role="status"
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <span>Save</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    )}
                </>
            )
            }
        </div >
    );
};

export default ConvertRecordingLogic;
